import { createFileRoute, Outlet } from "@tanstack/react-router";
import { applyAuthGuard } from "@/routes/-auth-guard";
import AuthLayout from "@/app/auth/layout";

export const Route = createFileRoute("/auth")({
  beforeLoad: ({ location }) =>
    applyAuthGuard(location.pathname, new URLSearchParams(location.searchStr)),
  component: () => (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  ),
});
